export enum EContactFormTopic {
  PURCHASES_NOT_RECEIVED = 'ContactView_problem_purchases_not_received',
  PROMOTION_PACK_NOT_RECEIVED = 'ContactView_problem_promotion_pack_not_received',
  REWARD_NOT_AVAILABLE = 'ContactView_problem_reward_not_available',
  RECEIVED_AND_DESCRIPTION_DISCREPANCY = 'ContactView_problem_received_and_description_discrepancy',
  NOT_WORKING_CODE = 'ContactView_problem_not_working_code',
  CANNOT_REDEEM_CODE = 'ContactView_problem_cannot_redeem_code',
  NOT_RECEIVED_DIAMONDS = 'ContactView_problem_not_received_diamonds',
  PAYMENT = 'ContactView_problem_payment',
  SEASON_TICKET = 'ContactView_problem_season_ticket',
  DAILY_BOOST = 'ContactView_problem_daily_boost',
  BUG = 'ContactView_problem_bug',
  OTHER = 'ContactView_problem_other',
}

export enum EContactInputs {
  SELECT = 'select',
  INPUT = 'input',
}

const purchaseDropdownOptions = [
  'ContactView_problem_purchases_not_received_type_lootpack',
  'ContactView_problem_purchases_not_received_type_lootticket',
  'your_details_other',
] as const;

const diamondsDropdownOptions = [
  'OfferWall_banner_bonus_missions',
  'OfferWall_banner_treasure_room',
  'OfferWall_banner_diamond_dungeon',
  'OfferWall_banner_diamond_dream',
  'OfferWall_banner_survey_quests',
  'OfferWall_banner_exploration_quests',
  'ContactView_problem_not_received_diamonds_type_quest',
  'ContactView_problem_not_received_diamonds_type_code',
  'your_details_other',
] as const;

const seasonTicketDropdownOptions = [
  'ContactView_problem_season_ticket_type_problem',
  'ContactView_problem_season_ticket_type_cancel',
  'ContactView_problem_season_ticket_type_can_not_subscribe',
  'your_details_other',
] as const;

interface IAdditionOption {
  attachmentText?: string;
  attachmentMandatory?: boolean;
  additionalField?: {
    Component: EContactInputs;
    label: string;
    options?: readonly string[];
  };
}

export const CONTACT_TOPICS: Record<EContactFormTopic, IAdditionOption> = {
  [EContactFormTopic.PURCHASES_NOT_RECEIVED]: {
    attachmentText: 'ContactView_screenshot_tip_not_all_packages_received',
    additionalField: {
      Component: EContactInputs.SELECT,
      label: 'ContactView_problem_purchases_not_received_type',
      options: purchaseDropdownOptions,
    },
  },
  [EContactFormTopic.PROMOTION_PACK_NOT_RECEIVED]: {
    additionalField: {
      Component: EContactInputs.INPUT,
      label: 'ContactView_problem_promotion_pack_not_received_type',
    },
  },
  [EContactFormTopic.REWARD_NOT_AVAILABLE]: {
    additionalField: {
      Component: EContactInputs.INPUT,
      label: 'ContactView_problem_reward_not_available_type',
    },
  },
  [EContactFormTopic.RECEIVED_AND_DESCRIPTION_DISCREPANCY]: {
    additionalField: {
      Component: EContactInputs.INPUT,
      label: 'ContactView_description_tip_which_package',
    },
  },
  [EContactFormTopic.NOT_WORKING_CODE]: {
    attachmentText: 'ContactView_screenshot_tip_not_working_code',
    attachmentMandatory: true,
  },
  [EContactFormTopic.NOT_RECEIVED_DIAMONDS]: {
    additionalField: {
      Component: EContactInputs.SELECT,
      label: 'ContactView_problem_not_received_diamonds_type',
      options: diamondsDropdownOptions,
    },
  },
  [EContactFormTopic.PAYMENT]: {
    attachmentText: 'ContactView_screenshot_tip_payment',
    additionalField: {
      Component: EContactInputs.INPUT,
      label: 'ContactView_problem_payment_type',
    },
  },
  [EContactFormTopic.SEASON_TICKET]: {
    additionalField: {
      Component: EContactInputs.SELECT,
      label: 'ContactView_problem_season_ticket_type',
      options: seasonTicketDropdownOptions,
    },
  },
  [EContactFormTopic.BUG]: {
    attachmentText: 'ContactView_screenshot_tip_payment',
  },
  [EContactFormTopic.CANNOT_REDEEM_CODE]: {},
  [EContactFormTopic.DAILY_BOOST]: {},
  [EContactFormTopic.OTHER]: {},
} as const;

export enum EContactFormField {
  EMAIL = 'email',
  USERNAME = 'username',
  TOPIC = 'subject',
  MESSAGE = 'message',
  ADDITIONAL_INFO = 'additionalInfo',
  SCREENSHOTS = 'screenshots',
}

export type TContactFormFieldValues = {
  [EContactFormField.EMAIL]: string;
  [EContactFormField.USERNAME]?: string;
  [EContactFormField.TOPIC]: EContactFormTopic;
  [EContactFormField.MESSAGE]?: string;
  [EContactFormField.ADDITIONAL_INFO]?: string;
  [EContactFormField.SCREENSHOTS]?: Array<File>;
};
